import { Slot } from "radix-ui";
import { type VariantProps } from "tailwind-variants";

import { iconButtonVariants } from "./variants";

type IconButtonVariants = VariantProps<typeof iconButtonVariants>;

interface IconButtonProps
  extends React.ComponentProps<"button">,
    IconButtonVariants {
  ariaLabel: string;
  children: React.ReactNode;
  asChild?: boolean;
}

const IconButton = ({
  className,
  variant,
  size,
  isRound,
  ariaLabel,
  asChild = false,
  ...props
}: IconButtonProps) => {
  const Comp = asChild ? Slot.Root : "button";

  return (
    <Comp
      aria-label={ariaLabel}
      className={iconButtonVariants({ variant, size, isRound, className })}
      {...props}
    />
  );
};

export { IconButton };
